<template>
  <div class="activity-results">
    <div class="box-title">
      <img src="@/assets/Vector (1).png" alt="" />
      <p>{{ props.title }}</p>
    </div>

    <div
      class="box-content"
      :class="{ 'ele-have-scrollbar': props.ele_have_scrollbar }"
    >
      <slot name="abc"></slot>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  title: {
    type: String,
    default: "标题",
  },
  custom: {
    type: Boolean,
    default: false,
  },
  ele_have_scrollbar: {
    type: Boolean,
    default: false,
  },
});











</script>

<style scoped lang="scss">
.activity-results {
  // width: 400px;
  // height: 581px;
  border-radius: 8px;
    // border: 1px solid red;
  background-color: #edf2ff;
  padding: 16px;
  display: flex;
  flex-direction: column;
  // justify-content: space-between;

  > .box-title {
    display: flex;
    margin-bottom: 16px;
    > img {
      width: 35px;
      height: 35px;
    }
    > p {
      font-size: 18px;
      font-weight: 700;
      color: #333333;
      margin-left: 8px;
      margin-top: 5px;
    }
  }

  > .box-content {
    width: 100%;
    height: 338px;
    border-radius: 8px;
    // border: 1px solid rgb(0, 255, 85);
    // background-color: #ffffff;
    // padding: 16px;
    overflow-y:auto;
  }
}
</style>
